import * as React from 'react';
import { Tooltip } from '../tooltip/tooltip';
import { InfoIcon } from '../../icons/icons-components/info';
import { namespacedClassnames } from '../../common/namespace-classes';
export var InfoTooltip = function (props) {
    var infoTooltipTriggerClassName = namespacedClassnames('info-tooltip', props.className);
    return (React.createElement(Tooltip, { body: props.text, relativeToBody: props.relativeToBody, className: infoTooltipTriggerClassName, align: props.tooltipAlign, forceHidden: props.forceHidden, forceVisible: props.forceVisible, direction: props.direction },
        React.createElement(InfoIcon, null)));
};
//# sourceMappingURL=info-tooltip.js.map